import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles, withStyles } from '@material-ui/styles';
import {
    Card,
    CardActions,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    IconButton,
    Menu,
    MenuItem,
    Checkbox,
    Collapse,
    Switch,
    lighten,
    Chip,
    TableContainer,
    Badge
} from '@material-ui/core';
import FiltradoData from 'utils/FiltradoData';
import { MoreVert, KeyboardArrowDown, KeyboardArrowUp, EmojiEvents, Palette } from '@material-ui/icons';
import FormatNumber from '../FormatNumber';
import TopBarTable from './TopBarTable';
import EnhancedTableHead from './enhancedTableHead';
import { Autocomplete } from '@material-ui/lab';
import './toPrint.css';

const useStyles = makeStyles(theme => ({
    root: {},
    filterButton: {
        marginRight: theme.spacing(2)
    },
    content: {
        padding: 0
    },
    inner: {
        width: '100%'
    },
    actions: {
        padding: theme.spacing(0, 1),
        justifyContent: 'flex-end'
    },
    seleccionados: {
        marginLeft: '0',
        marginRight: 'auto'
    },
    rowError: {
        backgroundColor: lighten(theme.palette.error.light, 0.5) + ' !important'
    },
    container: {
        maxHeight: 440
    },
    row: {
        //filter: 'blur(1px)',
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.action.disabled,
        pointerEvents: 'none'
    },
    success: {
        color: 'green'
    },
    danger: {
        color: 'red'
    },
    silver: {
        color: theme.palette.bono.silver
    },
    gold: {
        color: theme.palette.bono.gold
    }
}));
export const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        fontWeight: '700',
        padding: 0,
        '& ::placeholder': {
            fontWeight: '700',
            padding: theme.spacing(0.5),
            color: theme.palette.common.black,
            opacity: 1
        },
        '& .MuiButton-root': {
            padding: 0,
            '& .MuiButton-label': {
                justifyContent: 'space-between'
            }
        },
        '& .MuiButton-text': {
            fontWeight: '700',
            color: theme.palette.common.black
        }
    },
    body: {
        fontSize: 14,
        padding: theme.spacing(0.5),
        borderRight: '1px solid rgba(224, 224, 224, 1)'
    }
}))(TableCell);

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const Tabla = props => {
    const {
        keyTabla,
        className,
        columns,
        rows,
        accionesTabla,
        accionesFila,
        accionesFilaOrientacion,
        isSeleccionable,
        columnKey,
        DetailByrow,
        widthTable,
        onError,
        toolExtra,
        filterGeneralDisabled,
        onDisabled,
        optionsSelect,
        defaultV,
        verBono,
        register,
        change,
        errors,
        watch
    } = props;
    const classes = useStyles();
    const [filtros, setFiltros] = useState( { espesificos: {}, general: '' } );
    const [anchorEl, setAnchorEl] = useState({ current: null });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataTabla, setDataTabla] = useState(rows);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('calories');
    const [selected, setSelected] = useState([]);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    //metodos de paginacion
    const handleChangePage = (event, page) => {
        setPage(page);
    };
    const handleChangeRowsPerPage = event => {
        setPage(0);
        setRowsPerPage(event.target.value);
    };
    // fin paginacion
    // Columnas activas
    const [columnsActivas, setColumnsActivas] = useState(columns.filter(column => !column.hidden));
    // VARIABLE PARA CONTROLAR EL ERREGLO DE COLUMNAS A MOSTRARSE
    const [columnsInicio, setColumnsInicio] = useState(columns.filter(column => !column.hidden));
    // const columnsActivas = columns.filter(column => !column.hidden);
    //ARREGLO DE OPCIONES PARA MOSTRAR Y OCULTAR COLUMNAS
    const [newArray, setNewArray] = useState(columnsInicio.filter(column => !column.hidden).map(c => c.name));
    //metodos filtrado
    const dataf = FiltradoData(
        columnsActivas.map(column => column.name),
        filtros.espesificos[keyTabla],
        filtros.general,
        dataTabla
    );
    const cambioCampo = filtro => event => {
        setPage(0);
        if (filtro)
            setFiltros({
                general: filtros.general,
                espesificos: { ...filtros.espesificos, [keyTabla] :{...filtros.espesificos[keyTabla], [filtro]: event.target.value }}
            });
        else setFiltros({ ...filtros, general: event.target.value });
    };
    // fin filtrado
    // metodos Menu
    const abrirMenu = row => event => {
        setAnchorEl({ current: event.currentTarget, row: row });
    };
    const cerrarMenu = () => setAnchorEl({ ...anchorEl, current: null });
    // fin menu
    //metodos de selccionar
    const cambioSelccion = rowSelected => event => {
        if (isSeleccionable?.accion) isSeleccionable.accion(rowSelected, event.target.checked);
        setDataTabla(
            dataTabla.map(row => (row[columnKey] === rowSelected[columnKey] ? { ...row, isSeleccionado: !row.isSeleccionado } : row))
        );
    };
    const cambioSelccionAll = event => {
        if (isSeleccionable?.accionAll) isSeleccionable.accionAll(event.target.checked);
        if (Boolean(onDisabled))
            setDataTabla(
                dataTabla.map(row => ({
                    ...row,
                    isSeleccionado: !row.isdisabled ? event.target.checked : row.isSeleccionado
                }))
            );
        else
            setDataTabla(
                dataTabla.map(row => ({
                    ...row,
                    isSeleccionado: event.target.checked
                }))
            );
    };
    const seleccionados = dataf.filter(row => row.isSeleccionado == true);
    const clickExpandir = rowSelected => event => {
        setDataTabla(dataTabla.map(row => (row[columnKey] === rowSelected[columnKey] ? { ...row, expand: !row.expand } : row)));
    };
    const numColumns = columnsActivas.length + (DetailByrow != null) + (accionesFila.length > 0) + isSeleccionable;
    useEffect(() => {
        if (!Boolean(onDisabled)) {
            setDataTabla(rows);
            setNewArray(columnsInicio.filter(column => !column.hidden).map(c => c.name));
        } else setDataTabla(rows.map(row => ({ ...row, isdisabled: onDisabled(row) })));
    }, [rows]);

    const columnsOrden = [...columnsActivas];
    if (accionesFila.length > 0 && accionesFila.some(accion => Boolean(accion.enabled))) {
        columnsOrden.splice(accionesFilaOrientacion == 'rigth' ? columnsActivas.length : 0, 0, {
            label: '',
            name: 'opciones',
            disablePadding: true,
            type: {
                type: 'componente',
                accion: row => (
                    <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={abrirMenu(row)}>
                        {row['notificacion'] && row['notificacion'] > 0 ? (
                            <Badge badgeContent={row['notificacion'] ? row['notificacion'] : 0} color="secondary">
                                <MoreVert />
                            </Badge>
                        ) : (
                            <MoreVert />
                        )}
                    </IconButton>
                )
            }
        });
    }

    if (verBono && accionesFila.length > 0 && accionesFila.some(accion => Boolean(accion.enabled))) {
        columnsOrden.splice(accionesFilaOrientacion == 'left' ? columnsActivas.length : 0, 0, {
            label: '',
            name: 'opciones',
            disablePadding: true,
            type: {
                type: 'componente',
                accion: row => (
                    <IconButton
                        className={row['nvlbono'] == 2 ? classes.gold : classes.silver}
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        // disabled={true}
                        // color={classes.gold}
                    >
                        {row['idestatus'] == 5 && row['bono'] == 1 && <EmojiEvents />}
                    </IconButton>
                )
            }
        });
    }

    const dataEnbledCount = (Boolean(onDisabled) ? dataf.filter(row => !row.isdisabled) : dataf).length;

    const save = event => {
        let nuevo = [];
        let hiddenClm = [];
        if (newArray.includes(event.target.name)) {
            nuevo = removeItemFromArr(newArray, event.target.name);
            hiddenClm = columnsInicio.map(c => {
                return event.target.name === c.name ? { ...c, hidden: true } : c;
            });
            // columns.map(c =>{if(event.target.name === c.name){c.hidden = true} })
        } else {
            nuevo = [...newArray, event.target.name];
            hiddenClm = columnsInicio.map(c => {
                return event.target.name === c.name ? { ...c, hidden: false } : c;
            });
            // columns.map(c =>{if(event.target.name === c.name){c.hidden = false} })
        }
        setNewArray(nuevo);
        setColumnsActivas(hiddenClm.filter(column => !column.hidden));
        setColumnsInicio(hiddenClm);
    };

    const removeItemFromArr = (arr, item) => {
        return Object.values(arr).filter(function(e) {
            return e !== item;
        });
    };

    useEffect(() => {
        //localStorage.setItem('filtros', JSON.stringify(filtros));
        // if(filtrosTabla)
        //   setFiltrosTabla(filtros);
    }, [filtros]);

    return (
        <div className={clsx(classes.root, className)}>
            {!filterGeneralDisabled || accionesTabla.length ? (
                <TopBarTable
                    toolExtra={toolExtra}
                    data={seleccionados.length == 0 ? dataf : seleccionados}
                    seleccionados={seleccionados.length}
                    onChange={cambioCampo(null)}
                    busquedaValue={filtros.general}
                    accionesTabla={accionesTabla}
                    optionsSelect={optionsSelect}
                    defaultV={defaultV ? defaultV : ''}
                    register={register}
                    change={change}
                    errors={errors}
                    watch={watch}
                    save={save}
                    newArray={newArray}
                    filterGeneralDisabled={filterGeneralDisabled}
                    columns={columns} // .filter((column) => !column.hidden)
                />
            ) : null}
            <Card>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner} style={{ width: widthTable }}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        {isSeleccionable && (
                                            <StyledTableCell padding="checkbox">
                                                <Checkbox
                                                    indeterminate={seleccionados.length > 0 && seleccionados.length < dataEnbledCount}
                                                    checked={seleccionados.length == dataEnbledCount && seleccionados.length > 0}
                                                    onChange={cambioSelccionAll}
                                                />
                                            </StyledTableCell>
                                        )}
                                        <EnhancedTableHead
                                            columns={columnsOrden}
                                            classes={classes}
                                            numSelected={selected.length}
                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={handleRequestSort}
                                            rowCount={rows.length}
                                            filtros={filtros?.espesificos[keyTabla]}
                                            DetailByrow={DetailByrow}
                                            cambioSelccionAll={cambioSelccionAll}
                                            dataf={dataf}
                                            isSeleccionable={isSeleccionable}
                                            cambioCampo={cambioCampo}
                                            accionesFila={accionesFila}
                                        />
                                    </TableHead>
                                    <TableBody>
                                        {dataf.length <= 0 ? (
                                            <TableRow>
                                                <StyledTableCell colSpan={numColumns} align="center">
                                                    <Typography variant="subtitle1">No se encuentran registros</Typography>
                                                </StyledTableCell>
                                            </TableRow>
                                        ) : (
                                            stableSort(dataf, getComparator(order, orderBy))
                                                .slice(page * rowsPerPage, rowsPerPage * (page + 1))
                                                .map((data, index) => (
                                                    <React.Fragment key={'fila' + index}>
                                                        <TableRow
                                                            hover
                                                            disabled={true}
                                                            selected={data.isSeleccionado === true}
                                                            className={clsx(
                                                                Boolean(onError) && onError(data) && classes.rowError,
                                                                Boolean(data.isdisabled) && classes.row
                                                            )}
                                                        >
                                                            {isSeleccionable && (
                                                                <StyledTableCell padding="checkbox">
                                                                    <Checkbox
                                                                        onChange={cambioSelccion(data)}
                                                                        checked={data.isSeleccionado === true}
                                                                    />
                                                                </StyledTableCell>
                                                            )}
                                                            {DetailByrow != null && (
                                                                <StyledTableCell padding="checkbox">
                                                                    <IconButton size="small" onClick={clickExpandir(data)}>
                                                                        {data.expand ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                                    </IconButton>
                                                                </StyledTableCell>
                                                            )}
                                                            {columnsOrden.map(column => (
                                                                <StyledTableCell
                                                                    key={column.name}
                                                                    padding={column.disablePadding ? 'none' : 'default'}
                                                                >
                                                                    {column.type ? (
                                                                        ['entiempo'].includes(column.type) ? (
                                                                            (
                                                                                <Typography
                                                                                    className={
                                                                                        data[column.name] == 'ATRASADO'
                                                                                            ? classes.danger
                                                                                            : classes.success
                                                                                    }
                                                                                    variant="caption"
                                                                                    display="block"
                                                                                    color="secondary"
                                                                                    gutterBottom
                                                                                    align='center'
                                                                                >
                                                                                    {data[column.name]}
                                                                                </Typography>
                                                                            ) || '---'
                                                                        ) : ['money', 'cantidad'].includes(column.type) ? (
                                                                            <FormatNumber
                                                                                value={data[column.name] || 0}
                                                                                type={column.type}
                                                                            />
                                                                        ) : column.type.type == 'componente' ? (
                                                                            column.type.accion(data)
                                                                        ) : column.type.type == 'etiqueta' ? (
                                                                            <Chip
                                                                                color="primary"
                                                                                size="small"
                                                                                label={data[column.name]}
                                                                                style={
                                                                                    typeof column.style === 'function'
                                                                                        ? column.style(data)
                                                                                        : column.style
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <Switch
                                                                                checked={data[column.name] == '9'}
                                                                                onChange={column.type.accion(data)}
                                                                                disabled={
                                                                                    Boolean(column.type.disabled)
                                                                                        ? column.type.disabled(data)
                                                                                        : false
                                                                                }
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        (
                                                                            <Typography variant="caption" display="block" gutterBottom align='center'>
                                                                                {data[column.name]}
                                                                            </Typography>
                                                                        ) || '---'
                                                                    )}
                                                                </StyledTableCell>
                                                            ))}
                                                            {/* {accionesFila.length > 0 &&
                              <StyledTableCell padding="checkbox">
                                <IconButton
                                  aria-label="more"
                                  aria-controls="long-menu"
                                  aria-haspopup="true"
                                  onClick={abrirMenu(data)}
                                >
                                   <Badge badgeContent={data['notificacion']?data['notificacion']:0} color="secondary">
                                  <Badge badgeContent={data['notificacion']  ? data['notificacion'] : (data['notificacionDR'] ? data['notificacionDR'] :0)} color="secondary">
                                    <MoreVert />
                                  </Badge>
                                </IconButton>
                              </StyledTableCell>
                            } */}
                                                        </TableRow>
                                                        {DetailByrow != null && (
                                                            <TableRow>
                                                                <StyledTableCell
                                                                    style={{ paddingBottom: 0, paddingTop: 0 }}
                                                                    colSpan={numColumns}
                                                                >
                                                                    <Collapse in={data.expand}>{DetailByrow(data)}</Collapse>
                                                                </StyledTableCell>
                                                            </TableRow>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                <CardActions className={classes.actions}>
                    {seleccionados.length > 0 && (
                        <Typography variant="body2" className={classes.seleccionados}>
                            {seleccionados.length} Elemento(s) seleccionado(s).{' '}
                        </Typography>
                    )}
                    <TablePagination
                        component="div"
                        count={dataf.length}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        labelRowsPerPage="Filas por página"
                        rowsPerPageOptions={[5, 10, 15, 25]}
                        labelDisplayedRows={({ from, to, count }) =>
                            from + ' - ' + to + ' de ' + (count !== -1 ? count : 'more than ' + to)
                        }
                    />
                </CardActions>
            </Card>
            {accionesFila.length > 0 && (
                <Menu anchorEl={anchorEl.current} keepMounted open={Boolean(anchorEl.current)} onClose={cerrarMenu}>
                    {accionesFila
                        .filter(accion => (typeof accion.enabled === 'function' ? accion.enabled(anchorEl.row || {}) : accion.enabled))
                        .map((accion, index) => (
                            <MenuItem
                                key={'OpcionFila' + index}
                                style={{
                                    color: accion.notificacion && anchorEl.row.notificacion > 0 ? '#5C988D' : ''
                                }}
                                onClick={() => {
                                    accion.onClick(anchorEl.row);
                                    cerrarMenu();
                                }}
                            >
                                {accion.label}
                            </MenuItem>
                        ))}
                </Menu>
            )}
        </div>
    );
};
Tabla.propTypes = {
    widthTable: PropTypes.string,
    onError: PropTypes.func,
    onDisabled: PropTypes.func,
    accionesFila: PropTypes.array,
    filterGeneralDisabled: PropTypes.bool,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            hidden: PropTypes.bool,
            style: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
            filtrar: PropTypes.oneOfType([
                PropTypes.bool,
                PropTypes.shape({
                    id: PropTypes.string.isRequired,
                    value: PropTypes.string.isRequired,
                    ctl: PropTypes.arrayOf(PropTypes.object).isRequired
                }),
                PropTypes.arrayOf(PropTypes.string)
            ]),
            type: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({
                    type: PropTypes.string.isRequired,
                    accion: PropTypes.func
                })
            ])
        })
    ).isRequired,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    accionesTabla: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.element.isRequired,
            click: PropTypes.func.isRequired,
            dataSelected: PropTypes.bool,
            disabled: PropTypes.bool
        })
    ),
    accionesFilaOrientacion: PropTypes.oneOf(['left', 'rigth']),
    accionesFila: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            enabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired
        })
    ),
    isSeleccionable: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            accion: PropTypes.func.isRequired,
            accionAll: PropTypes.func.isRequired
        })
    ]),
    columnKey: PropTypes.string.isRequired,
    DetailByrow: PropTypes.func
};
Tabla.defaultProps = {
    accionesFila: [],
    accionesFilaOrientacion: 'rigth',
    accionesTabla: [],
    filterGeneralDisabled: false,
    isSeleccionable: false,
    rows: [],
    widthTable: '100%'
};
export default Tabla;
